export default __webpack_public_path__ + "static/media/working-at-desk.3005f20d.svg";